import type { KeyboardEvent as ReactKeyboardEvent } from "react"
import { cva } from "class-variance-authority"

const resizeHandleVariants = cva(
  [
    "absolute left-0 top-0 h-full w-2 -translate-x-1/2",
    "cursor-col-resize rounded-sm border-l border-transparent",
    "transition-colors",
    "focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-primary",
  ],
  {
    variants: {
      isResizing: {
        true: "bg-border",
        false: "bg-transparent hover:bg-border/50",
      },
    },
    defaultVariants: {
      isResizing: false,
    },
  }
)

interface ResizeHandleProps {
  ariaLabel?: string
  width: number
  minWidth: number
  maxWidth: number
  isResizing: boolean
  onResizeStart: (clientX: number) => void
  onKeyDown: (event: ReactKeyboardEvent<HTMLDivElement>) => void
}

const ResizeHandle = ({
  ariaLabel = "Resize panel width",
  width,
  minWidth,
  maxWidth,
  isResizing,
  onResizeStart,
  onKeyDown,
}: ResizeHandleProps) => {
  return (
    <div
      className={resizeHandleVariants({ isResizing })}
      role="separator"
      aria-orientation="vertical"
      aria-label={ariaLabel}
      aria-valuemin={minWidth}
      aria-valuemax={maxWidth}
      aria-valuenow={width}
      tabIndex={0}
      onMouseDown={(e) => {
        e.preventDefault()
        onResizeStart(e.clientX)
      }}
      onTouchStart={(e) => {
        e.preventDefault()
        onResizeStart(e.touches[0].clientX)
      }}
      onKeyDown={onKeyDown}
    >
      {/* Invisible hit area for easier grabbing */}
      <div className="absolute left-1/2 top-0 h-full w-2 -translate-x-1/2" />
    </div>
  )
}

export default ResizeHandle
